<template>
  <div>
    <div
      class="my-1 mx-2"
      v-if="!disabled"
    >
      <v-menu
        ref="menu"
        v-model="timemenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-row
            class="dummy-row"
            v-on="on"
          >
            <input
              type="text"
              class="form-control"
              readonly
              v-model="time"
              :disabled="disabled"
              :required="required"
            >
          </v-row>
        </template>

        <v-time-picker
          v-if="timemenu"
          v-model="time"
          format="24hr"
          full-width
          @click:minute="$refs.menu.save(time)"
        />
      </v-menu>
    </div>
    <div
      class="my-1 mx-2"
      v-else
    >
      <v-row class="dummy-row">
        <input
          type="text"
          class="form-control"
          :value="time"
          disabled
        >
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "targetTime",
    event: "input"
  },
  props: {
    targetTime: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timemenu: false
    };
  },
  computed: {
    time: {
      get() {
        return this.targetTime;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  created() {
    if (this.targetTime) {
      this.time = this.targetTime;
    }
  }
};
</script>

<style lang="scss" scoped>
.dummy-row {
  margin: 0 !important;
  display: block !important;
}
</style>
